import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import dataCommonSlice from './slices/dataCommonSlice';
import adsOptimizationSlice from './slices/adsOptimizationSlice';
import adminSettingsReducer from '../modules/AdminSettings/reducers';
import categoryManagementReducer from '../modules/CategoryManagement/reducers';
import skuItemsReducer from '../modules/SkuItems/reducers';
import listingsReducer from '../modules/Listings/reducers';
import ordersReducer from '../modules/Orders/reducers';
import orderDetailReducer from '../modules/OrderDetail/reducers';
import inboxReducer from '../modules/Inbox/reducers';
import shopifyProductsReducer from '../modules/shopify/ShopifyProducts/reducers';
import shopifyVariantsReducer from '../modules/shopify/ShopifyVariants/reducers';
import shopifySettingsReducer from '../modules/shopify/ShopifySettings/reducers';
import shopifyCategoriesReducer from '../modules/shopify/ShopifyCategories/reducers';
import shopifyOrdersReducer from '../modules/ShopifyOrders/reducers';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    orders: ordersReducer,
    orderDetail: orderDetailReducer,
    dataCommon: dataCommonSlice,
    adsOptimization: adsOptimizationSlice,
    adminSettings: adminSettingsReducer,
    categoryManagement: categoryManagementReducer,
    skuItems: skuItemsReducer,
    listings: listingsReducer,
    inbox: inboxReducer,
    shopifyProducts: shopifyProductsReducer,
    shopifyVariants: shopifyVariantsReducer,
    shopifySettings: shopifySettingsReducer,
    shopifyCategories: shopifyCategoriesReducer,
    shopifyOrders: shopifyOrdersReducer,
  },
  // Disable serializable and immutable checks for adsOptimization slice
  // These middleware cause severe lag when dragging nodes (100ms+ per mouse move)
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these paths in the state for serializable check
        ignoredPaths: ['adsOptimization'],
        // Ignore these action types
        ignoredActions: [
          'adsOptimization/setNodes',
          'adsOptimization/setEdges',
          'adsOptimization/loadFlow',
          'adsOptimization/updateNode',
          'adsOptimization/addNode',
          'adsOptimization/setCurrentRule',
          'adsOptimization/setExecutionResult',
          'adsOptimization/saveToHistory',
        ],
      },
      immutableCheck: {
        // Ignore adsOptimization state for immutable checks
        ignoredPaths: ['adsOptimization'],
      },
    }),
});

export default store;